<template>
    <div class="login-container">
        <div class="form-side">
            <div class="login-box">
                <div class="weeduc-lang-switcher-wrap">
                    <LanguageSwitcher class="weeduc-lang-switcher--light" />
                </div>
                <div class="logo">
                    <img src="@/assets/logo.png" alt="Logo Weeduc" />
                </div>
                <div class="forgot-password-content">
                    <h3>{{ $t('auth.forgotPassword') }}</h3>
                    <p>{{ $t('auth.forgotLead') }}</p>
                    
                    <form @submit.prevent="handleForgotPassword">
                        <div class="form-group">
                            <label>{{ $t('auth.email') }}</label>
                            <input 
                                type="email"
                                v-model="email"
                                :placeholder="$t('auth.emailPlaceholder')"
                                required
                            />
                        </div>
                        
                        <div v-if="errorMessage" class="error-message">
                            {{ errorMessage }}
                        </div>
                        
                        <div v-if="successMessage" class="success-message">
                            {{ successMessage }}
                        </div>
                        
                        <button type="submit" class="btn-submit" :disabled="isLoading">
                            {{ isLoading ? $t('auth.sending') : $t('auth.sendInstructions') }}
                        </button>
                    </form>
                    
                    <div class="links">
                        <a href="/portal">{{ $t('auth.backToLogin') }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="banner-side">
            <div class="banner-content">
            </div>
        </div>
    </div>
</template>

<script>
import apiPassword from '@/utils/password.js';
import LanguageSwitcher from '@/components/i18n/LanguageSwitcher.vue';
import { isRateLimited } from '@/utils/rateLimit';

export default {
    components: {
        LanguageSwitcher,
    },
    data() {
        return {
            email: '',
            errorMessage: '',
            successMessage: '',
            isLoading: false
        }
    },
    methods: {
        async handleForgotPassword() {
            this.errorMessage = '';
            this.successMessage = '';
            this.isLoading = true;

            try {
                const payload = {
                    email: this.email,  
                    typeSystem: 1
                }

                await apiPassword.resetPassowrdEmail(payload);

                this.successMessage = this.$t('auth.emailSentIfExists');
                this.email = '';

            } catch (error) {
                console.error('Erro ao solicitar recuperação de senha:', error);
                this.errorMessage = isRateLimited(error)
                    ? this.$t('auth.tooManyAttempts')
                    : this.$t('auth.recoveryError');
            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>

<style scoped>
.login-container {
    display: flex;
    min-height: 100vh;
}

.banner-side {
    flex: 1;
    background-image: url('@/assets/portal/Login-weeduc.png');
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    position: relative;
}

.banner-content {
    position: relative;
    text-align: center;
    padding: 1.25rem;
}

.form-side {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    padding: 2.5rem;
    width: 35%;
}

.login-box {
    width: 100%;
    max-width: 25rem;
    background: white;
    padding: 2.5rem;
    border-radius: 0.5rem;
    box-shadow: 0 0.125rem 0.625rem rgba(0,0,0,0.1);
}

.weeduc-lang-switcher-wrap {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0.75rem;
}

.logo {
    text-align: center;
    margin-bottom: 1.875rem;
}

.logo img {
    width: 12.5rem;
}

.forgot-password-content {
    text-align: center;
}

.forgot-password-content h3 {
    color: #272f3a;
    margin-bottom: 1rem;
    font-size: 1.5rem;
}

.forgot-password-content p {
    color: #757e8a;
    margin-bottom: 1.5rem;
    font-size: 0.9rem;
    line-height: 1.4;
}

.form-group {
    margin-bottom: 1.25rem;
}

label {
    display: block;
    margin-bottom: 0.5rem;
    color: #757e8a;
    text-align: left;
}

input {
    width: 100%;
    padding: 0.75rem;
    border: 0.0625rem solid #ddd;
    border-radius: 0.25rem;
    font-size: 0.875rem;
}

.error-message {
    color: #d32f2f;
    background: #fff0f0;
    border: 1px solid #d32f2f;
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 15px;
    font-size: 0.9em;
    text-align: center;
}

.success-message {
    color: #2e7d32;
    background: #f0fff0;
    border: 1px solid #2e7d32;
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 15px;
    font-size: 0.9em;
    text-align: center;
}

.btn-submit {
    width: 93%;
    padding: 0.75rem;
    background-color: #3db8bf;
    color: white;
    border: none;
    border-radius: 0.25rem;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
    margin: 10px;
}

.btn-submit:hover:not(:disabled) {
    background-color: #2a9ca3;
}

.btn-submit:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.links {
    margin-top: 20px;
    text-align: center;
}

.links a {
    color: #3db8bf;
    text-decoration: none;
    font-size: 14px;
}

.links a:hover {
    color: #2a9ca3;
    text-decoration: underline;
}

@media (max-width: 48rem) {
    .login-container {
        flex-direction: column;
    }
    
    .banner-side {
        display: none;
    }
    
    .form-side {
        padding: 1.25rem;
        width: 100%;
        height: 100vh;
    }
    
    .login-box {
        padding: 1.25rem;
    }
}
</style>
